var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBzz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.85 3.909 3.398-1.91 3.426 1.923V7.77l-3.397 1.903-.029-.015-3.402-1.908V3.937l.005-.028zM8.428 29.999 2 26.393v-7.2l6.427-3.613 6.428 3.612v7.2L8.427 30zm21.139-10.808-6.428-3.612-6.427 3.612v7.2L23.14 30l6.428-3.607v-7.2zM9.315 6.614l6.418-3.607 2.462 1.47v4.241l.844.473 3.13 1.757v2.868l-6.428 3.607-6.427-3.607v-7.2z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBzz);
export default __webpack_public_path__ + "static/media/BZZ.18dfa3688c7a4cc655b1534eb7fd79e7.svg";
export { ForwardRef as ReactComponent };